'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { urlBuilder } from '@/shared/utils';

/* Страницы, с которых пользователя без пройденного онбординга уводим на анкету */
const GUARDED_PATH_PATTERNS = [
	/^\/problems$/,
	/^\/roadmap\/[^/]+$/,
	/^\/courses$/,
	/^\/course\/[^/]+$/,
];

export function useOnboardingRedirect(isNeedOnboarding: boolean) {
	const pathname = usePathname();
	const router = useRouter();

	useEffect(() => {
		if (!isNeedOnboarding) {
			return;
		}

		const isGuardedPath = GUARDED_PATH_PATTERNS.some((pattern) =>
			pattern.test(pathname),
		);

		if (isGuardedPath) {
			router.replace(urlBuilder.onboarding());
		}
	}, [isNeedOnboarding, pathname, router]);
}
